import { render, staticRenderFns } from "./penerimaanFppk.vue?vue&type=template&id=f770a9d0"
import script from "./penerimaanFppk.vue?vue&type=script&lang=js"
export * from "./penerimaanFppk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports